import ENV from "config/Env";
import { typedQueryClient, usePermanentRealTimeUser, useTypedMutation } from "hooks";
import { AppointmentDetailsKeys } from "modules/AppointmentDetails/queryKeys";
import { ApiInstance } from "utils/Api";
import { toISOString } from "utils/dateHelperFunctions";

export type ThreeDepartmentPayload = {
  appointment_id: number;
  receptionist: boolean | null;
  parts: boolean | null;
  workshop: boolean | null;
  remark: string;
};

export const useUpdateThreeDepartmentMutation = () => {
  const { user } = usePermanentRealTimeUser();

  return useTypedMutation({
    mutationFn: (payload: ThreeDepartmentPayload) => ApiInstance.post("/three_departments/update", payload, ENV.appointmentBaseURL),
    onSuccess: payload => {
      const appointment = typedQueryClient.getQueryData(AppointmentDetailsKeys.view);
      if (!appointment || appointment.id !== payload.appointment_id) return;

      const hasReceptionistChanged = payload.receptionist !== null;
      const hasPartsChanged = payload.parts !== null;
      const hasWorkshopChanged = payload.workshop !== null;
      const hasRemarkChanged = payload.remark !== appointment.three_department_remark;

      if (!hasReceptionistChanged && !hasPartsChanged && !hasWorkshopChanged && !hasRemarkChanged) return;

      const userId = user?.id ?? null;
      const today = toISOString(new Date());

      typedQueryClient.setQueryData(AppointmentDetailsKeys.view, {
        ...appointment,
        ...(payload.receptionist !== null && {
          three_department_receptionist: payload.receptionist,
          three_department_receptionist_set_at: today,
          three_department_receptionist_user_id: userId,
          three_department_receptionist_user: user
        }),
        ...(payload.parts !== null && {
          three_department_parts: payload.parts,
          three_department_parts_set_at: today,
          three_department_parts_user_id: userId,
          three_department_parts_user: user
        }),
        ...(payload.workshop !== null && {
          three_department_workshop: payload.workshop,
          three_department_workshop_set_at: today,
          three_department_workshop_user_id: userId,
          three_department_workshop_user: user
        }),
        ...(hasRemarkChanged && {
          three_department_remark: payload.remark,
          three_department_remark_updated_at: today,
          three_department_remark_user_id: userId,
          three_department_remark_user: user
        })
      });
    }
  });
};
